import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=6c44cf04&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=ts"
export * from "./SingleOrder.vue?vue&type=script&lang=ts"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&id=6c44cf04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44cf04",
  null
  
)

export default component.exports